import React, { useState, useEffect } from "react";
import ReactTable from "common/components/ReactTable/ReactTable";
import ModalBootstrap from "components/bootstrap/ModalBootstrap";
import { useTranslation } from "react-i18next";
import {
  useGetControllersSummaryQuery,
  useGetReportsByControllerQuery,
} from "features/api/reports/reportsSlice";
import Header from "../Components/Header";
import { FilterFields } from "../Components/types";
import {
  getControllersExtraDataTableColumns,
  getControllersTableColumns,
} from "../utils";
import ExtraDataModal from "../Components/ExtraDataModal";

const ControllersReport = () => {
  const { t } = useTranslation();
  const [filterValues, setFilterValues] = useState<FilterFields[]>([]);
  const [pageIndex, setPageIndex] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [data, setData] = useState([]);
  const [extraDatafilterValues, setExtraDataFilterValues] = useState<
    FilterFields[]
  >([]);
  const [extraDataPageIndex, setExtraDataPageIndex] = useState(1);
  const [extraDataPageCount, setExtraDataPageCount] = useState(0);
  const [extraData, setExtraData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading] = useState(false);
  const [controllerName, setControllerName] = useState("");
  const [controllerId, setControllerId] = useState("");
  const excelEndpoint = `GetContollersSummaryAsExcelFile`;

  const onCellClick = (controllerNumberId: string, fullName: string) => {
    setControllerName(fullName);
    setControllerId(controllerNumberId);
    setExtraDataPageIndex(1);
    setIsModalOpen(true);
  };

  const columns = getControllersTableColumns(onCellClick);
  const extraDatacolumns = getControllersExtraDataTableColumns;

  const filterObject = filterValues.reduce(
    (acc, cur) => ({ ...acc, [cur.field]: cur.value }),
    {}
  );

  const filterExtraDataObject = extraDatafilterValues.reduce(
    (acc, cur) => ({ ...acc, [cur.field]: cur.value }),
    {}
  );

  const submitFilter = (filters: FilterFields[]) => {
    setFilterValues(filters);
  };

  const submitFilterExtraData = (filters: FilterFields[]) => {
    setExtraDataFilterValues(filters);
  };

  const { data: extraDataResponse, isFetching: isFetchingExtraData } =
    useGetReportsByControllerQuery(
      {
        controllerId,
        filter: filterExtraDataObject,
        page: extraDataPageIndex,
      },
      {
        skip: !controllerId, // Only run the query if licenseNumber is set
      }
    );

  useEffect(() => {
    if (!isFetchingExtraData && extraDataResponse) {
      setExtraData(extraDataResponse.objectList || []);
      setExtraDataPageCount(extraDataResponse.totalPages || 0);
    }
  }, [extraDataResponse, isFetchingExtraData]);

  return (
    <div style={{ paddingBottom: 20 }}>
      <div>{t("InitializeReportsWindowForControlCenter")}</div>

      <Header
        columns={columns}
        submitFilter={submitFilter}
        filterValues={filterValues}
        thereIsData={data?.length > 0}
        excelEndpoint={excelEndpoint}
      />
      <ReactTable
        data={data}
        columns={columns}
        pageIndex={pageIndex}
        setPageIndex={setPageIndex}
        pageCount={pageCount}
      />
      <ModalBootstrap
        onHide={() => setIsModalOpen(false)}
        show={isModalOpen}
        dialogClassName="extra-data-modal"
        isWithFooter={false}
      >
        <ExtraDataModal
          title={`${t("reportsThatCompleted")} ${t("by")} ${controllerId}`}
          titleFor={controllerId}
          isLoading={isLoading}
          data={extraData}
          columns={extraDatacolumns}
          pageIndex={extraDataPageIndex}
          setPageIndex={setExtraDataPageIndex}
          pageCount={extraDataPageCount}
          submitFilter={submitFilterExtraData}
          filterValues={extraDatafilterValues}
        />
      </ModalBootstrap>
    </div>
  );
};

export default ControllersReport;
